import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "charts-dashboard__empty-state" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }




export default /*@__PURE__*/_defineComponent({
  __name: 'empty-state',
  props: {
    type: {},
    onOpenList: { type: Function },
    onCreateList: { type: Function }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_PxButton = _resolveComponent("PxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "icon" }, [
      _createElementVNode("img", { src: "img/no-matches.svg" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (props.type === 'lists')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "No lists available."))
        : _createCommentVNode("", true),
      (props.type === 'lists')
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " You havent created any lists yet. Start by creating a new list to keep track of relevant companies "))
        : _createCommentVNode("", true),
      (props.type === 'companies')
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "No companies in the list."))
        : _createCommentVNode("", true),
      (props.type === 'companies')
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Start adding companies to track your network’s milestone progress. "))
        : _createCommentVNode("", true)
    ]),
    (props.type === 'lists')
      ? (_openBlock(), _createBlock(_component_PxButton, {
          key: 0,
          type: "green",
          class: "cta",
          onClick: props.onCreateList
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PxIcon, {
              size: 18,
              name: "plus-white"
            }),
            _cache[0] || (_cache[0] = _createTextVNode(" NEW LIST ", -1))
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (props.type === 'companies')
      ? (_openBlock(), _createBlock(_component_PxButton, {
          key: 1,
          type: "green",
          class: "milestone-progress-reports__nocompanies__cta",
          onClick: props.onOpenList
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" OPEN LIST ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}
}

})